module.exports = __webpack_public_path__ + "img/settings.fa12e7b.svg";